import { postData } from "./axiosConfig"

export const postStrip = async (body) => {
    return await postData("user/order/create-payment-intent", body)
}